/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取激活统计列表
export function getActivationStatisticsList(params) {
    return request({
        url: 'activationStatistics/list.do?',
        method: 'post',
        data: params
    })
}

// 编辑激活统计数据
export function updateActivationStatistics(params) {
    return request({
        url: 'activationStatistics/update.do?',
        method: 'post',
        data: params
    })
}

// 导出激活统计列表
export function exportActivationStatistics(params) {
    return request({
        url: 'activationStatistics/exportExcel.do?',
        method: 'post',
        data: params
    })
}

// 获取代理商列表
export function agentListForUser(params) {
    return request({
        url: '/agent/listForUser.do?',
        method: 'post',
        data: params,
    })
} 